import RoleStore from "./administrator/roleStore"
import BundleStore from "./administrator/bundleStore"
import TenantStore from "./administrator/tenantStore"
import UserStore from "./administrator/userStore"
import SessionStore from "./sessionStore"
import AuthenticationStore from "./authenticationStore"
import AccountStore from "./accountStore"
import LanguageStore from "./administrator/languageStore"

import NewsCategoryStore from "./communication/newsCategoryStore"

import FileStore from "./common/fileStore"
import AuditLogStore from "./common/auditLogStore"
import CommentStore from "./common/commentStore"

import NotificationTemplateStore from "./notificationTemplate/notificationTemplateStore"
import ReminderStore from "@stores/common/reminderStore"
import NotificationCenterStore from "@stores/notification/notificationCenterStore"
import NotificationDeliveryStore from "@stores/notification/notificationDeliveryStore"
import NotificationAuditLogStore from "@stores/notification/notificationAuditLogStore"

import MasterDataStore from "@stores/master-data/masterDataStore"

import { appDataStoreInstance } from "./appDataStore"
import { downloadRequestStoreInstance } from "./downloadCenter/downloadRequestStore"
import { uiProgressStoreInstance } from "./ui/uiProgressStore"

import CompanyStore from "./clientManagement/companyStore"
import ContactStore from "./clientManagement/contactStore"

import OpportunityStore from "./opportunity/opportunityStore"
import ActivityStore from "./activity/activityStore"
import DepositStore from "./activity/depositStore"
import ProposalStore from "./activity/proposalStore"
import CallStore from "./activity/callStore"
import MailStore from "./activity/mailStore"
import ReservationStore from "./activity/reservationStore"
import SiteVisitStore from "./activity/siteVisitStore"
import MeetingStore from "./activity/meetingStore"
import CalendarStore from "./activity/calendarStore"

import CampaignStore from "./campaign/campaignStore"
import TargetStore from "./campaign/targetStore"

// import OpportunityCommercialStore from "./opportunity/opportunityCommercialStore";
// import DealContractStore from "./dealContracts/dealContractStore";

import RequirementStore from "./projects/requirementStore"
import UnitStore from "./projects/unitStore"
import ListingStore from "./projects/listingStore"

import InquiryStore from "./communication/inquiryStore"

import OpportunityCommercialStore from "./opportunity/opportunityCommercialStore"
import OrganizationUnitStore from "./organizationUnit/organizationUnitStore"
import CustomerStore from "./customer/customerStore"
import BookingStore from "./booking/bookingStore"
import CartStore from "./cart/cartStore"
import FilterStore from "./filter/filterStore"
import AgencyMasterStore from "./agencyMaster/agencyMasterStore"
import CustomerSourceStore from "./master-data/customerSourceStore"
import ProjectFacilityStore from "./master-data/projectFacilityStore"
import TownShipStore from "./master-data/townShipStore"
import UnitDesignStore from "./master-data/unitDesignStore"
import UnitFacilityStore from "./master-data/unitFacilityStore"
import UnitTypeStore from "./master-data/unitTypeStore"
import ProjectMasterStore from "./master-data/projectMasterStore"
import UnitMasterStore from "./master-data/unitMasterStore"
import ImportStore from "./common/importStore"
import FeedbackStore from "./feedback/feedbackStore"
import SaleEventStore from "./saleEvent/saleEventStore"
import WfStatusStore from "./workflow/wfStatusStore"
import WfRoleStore from "./workflow/wfRoleStore"
import WfPriorityStore from "./workflow/wfPriorityStore"
import WfTrackerStore from "./workflow/wfTrackerStore"
import WfCustomFieldStore from "./workflow/wfCustomFieldStore"
import WfConfigurationStore from "./workflow/wfConfigurationStore"
import WorkflowStore from "./workflow/workflowStore"
import PinkBookStore from "./pinkBook/pinkBookStore"
import ContractStore from "./contract/contractStore"
import SalePolicyStore from "./salePolicy/salePolicyStore"
import PromotionProgramStore from "./promotionProgram/promotionProgramStore"
import PaymentScheduleStore from "./paymentSchedule/paymentScheduleStore"
import ApprovalStore from "./approval/approvalStore"
import HandoverStore from "./handover/handoverStore"
import InvitationStore from "./invitationStore/invitationStore"
import TowerStore from "./master-data/towerStore"
import PricingApprovalStore from "./pricingApproval/pricingApprovalStore"
import TradingFloorStore from "./floorStaff/tradingFloorStore"
import BussinessTargetStore from "./floorStaff/bussinessTargetStore"
import AllocatedCustomerStore from "./floorStaff/allocatedCustomerStore"
import FloorStaffStore from "./floorStaff/floorStaffStore"
import BookingReservationStore from "./booking/bookingReservationStore"
import PaymentMasterStore from "./master-data/paymentMasterStore"
import PropertyTypeStore from "./master-data/propertyTypeStore"
import ViewStore from "./master-data/viewStore"
import ContractEventStore from "./contract/contractEventStore"
import ConfigurationPaymentStore from "./configurationPaymentStore/configurationPaymentStore"
import FeeTypeStore from "./feeType/FeeTypeStore"
import InquiryFeeTypeSettingStore from "./receiptType/inquiryFeeTypeSettingStore"
import PhaseCodeStore from "./phaseCode/phaseCodeStore"
import SystemConfigurationStore from "./system/SystemConfigurationStore"
import ReportStore from "./report/reportStore"
import DashboardStore from "./report/dashboardStore"
import Entity360Store from "./entity360/entity360Store"
import DashboardCsStore from "./dashboard/dashboardCsStore"
import DashboardFinanceStore from "./dashboard/dashboardFinanceStore"
import DashboardSalesStore from "./dashboard/dashboardSalesStore"
import DashboardExecutiveStore from "./dashboard/dashboardExecutiveStore"
import ApprovalProcessStore from "./approvalProcess/approvalProcessStore"
import AccountTypeStore from "./master-data/accountingData/accountTypeStore"
import AccountingDocumentTypeStore from "./master-data/accountingData/accountingDocumentTypeStore"
import CostCenterStore from "./master-data/accountingData/costCenterStore"
import OffsetAccountStore from "./master-data/accountingData/offsetAccountStore"
import SuspenseAccountSettingStore from "./master-data/accountingData/suspenseAccountSettingStore"
import PaymentRequestStore from "./master-data/paymentRequestStore"
import CompanyPrintTemplateStore from "./master-data/companyPrintTemplateStore"
import ZoneStore from "./master-data/zoneStore"
import ConfigHolidayStore from "./configHoliday/configHolidayStore"
import ContractInquiryStore from "./contract/contractInquiryStore"
import FeeNotificationStore from "./feeNotification/FeeNotificationStore"
import FeeReminderLadderStore from "./feeNotification/FeeReminderLadderStore"
import FeeNotificationReportStore from "./feeNotificationReport/feeNotificationReportStore"
import BlockUserStore from "./blockUser/blockUserStore"
import ContractInterestSettingStore from "./contractInterestSetting/contractInterestSettingStore"
import ImportJobLogStore from "./common/importJobLogStore"
import FloorStore from "./master-data/floorStore"
import GroupStore from "./master-data/groupStore"
import CustomerPotentialStore from "./customer/customerPotentialStore"
import IntegrationResultStore from "./integrationResult/integrationResultStore"
import IntegrationHubStore from "./integrationHub/integrationHubStore"
import ApprovalInboxOutboxStore from "./approvalInboxOutbox/approvalInboxOutboxStore"
import PinkBookFeeUpdateStore from "./pinkBookFeeUpdate/pinkBookFeeUpdateStore"
import ApproverGroupStore from "./approverGroup/approverGroupStore"
import ExportJobLogStore from "./export/exportJobLogStore"
import CodeFormatTemplateStore from "./codeFormatTemplate/codeFormatTemplateStore"

export default function initializeStores() {
  return {
    authenticationStore: new AuthenticationStore(),
    roleStore: new RoleStore(),
    bundleStore: new BundleStore(),
    tenantStore: new TenantStore(),
    userStore: new UserStore(),
    sessionStore: new SessionStore(),
    accountStore: new AccountStore(),
    languageStore: new LanguageStore(),
    appDataStore: appDataStoreInstance,
    uiProgressStore: uiProgressStoreInstance,
    downloadRequestStore: downloadRequestStoreInstance,

    // News & Event
    newsCategoryStore: new NewsCategoryStore(),

    auditLogStore: new AuditLogStore(),
    fileStore: new FileStore(),
    commentStore: new CommentStore(),
    notificationTemplateStore: new NotificationTemplateStore(),
    reminderStore: new ReminderStore(),
    notificationCenterStore: new NotificationCenterStore(),
    notificationDeliveryStore: new NotificationDeliveryStore(),
    notificationAuditLogStore: new NotificationAuditLogStore(),

    masterDataStore: new MasterDataStore(),

    companyStore: new CompanyStore(),
    contactStore: new ContactStore(),

    opportunityStore: new OpportunityStore(),
    // opportunityCommercialStore: new OpportunityCommercialStore(),
    // dealContractStore: new DealContractStore(),

    activityStore: new ActivityStore(),
    depositStore: new DepositStore(),
    proposalStore: new ProposalStore(),
    callStore: new CallStore(),
    mailStore: new MailStore(),
    reservationStore: new ReservationStore(),
    siteVisitStore: new SiteVisitStore(),

    meetingStore: new MeetingStore(),
    calendarStore: new CalendarStore(),

    targetStore: new TargetStore(),
    campaignStore: new CampaignStore(),

    requirementStore: new RequirementStore(),
    unitStore: new UnitStore(),
    listingStore: new ListingStore(),
    inquiryStore: new InquiryStore(),

    opportunityCommercialStore: new OpportunityCommercialStore(),
    organizationUnitStore: new OrganizationUnitStore(),
    reportStore: new ReportStore(),
    dashboardStore: new DashboardStore(),
    dashboardCsStore: new DashboardCsStore(),
    dashboardFinanceStore: new DashboardFinanceStore(),
    dashboardSalesStore: new DashboardSalesStore(),
    dashboardExecutiveStore: new DashboardExecutiveStore(),
    entity360Store: new Entity360Store(),

    // Master store
    customerSourceStore: new CustomerSourceStore(),
    projectFacilityStore: new ProjectFacilityStore(),
    townShipStore: new TownShipStore(),
    unitDesignStore: new UnitDesignStore(),
    unitFacilityStore: new UnitFacilityStore(),
    unitTypeStore: new UnitTypeStore(),
    projectMasterStore: new ProjectMasterStore(),
    unitMasterStore: new UnitMasterStore(),
    towerStore: new TowerStore(),
    zoneStore: new ZoneStore(),
    paymentMasterStore: new PaymentMasterStore(),
    propertyTypeStore: new PropertyTypeStore(),
    viewStore: new ViewStore(),
    paymentRequestStore: new PaymentRequestStore(),
    floorStore: new FloorStore(),
    groupStore: new GroupStore(),
    companyPrintTemplateStore: new CompanyPrintTemplateStore(),
    // work flow
    wfStatusStore: new WfStatusStore(),
    wfRoleStore: new WfRoleStore(),
    wfPriorityStore: new WfPriorityStore(),
    wfTrackerStore: new WfTrackerStore(),
    wfCustomFieldStore: new WfCustomFieldStore(),
    wfConfigurationStore: new WfConfigurationStore(),
    workflowStore: new WorkflowStore(),

    //  CRM
    filterStore: new FilterStore(),
    feedbackStore: new FeedbackStore(),
    importStore: new ImportStore(),
    saleEventStore: new SaleEventStore(),
    pinkBookStore: new PinkBookStore(),
    contractStore: new ContractStore(),
    promotionProgramStore: new PromotionProgramStore(),
    salePolicyStore: new SalePolicyStore(),
    paymentScheduleStore: new PaymentScheduleStore(),

    approvalStore: new ApprovalStore(),
    cartStore: new CartStore(),
    customerStore: new CustomerStore(),
    customerPotentialStore: new CustomerPotentialStore(),
    bookingStore: new BookingStore(),
    bookingReservationStore: new BookingReservationStore(),
    handoverStore: new HandoverStore(),
    invitationStore: new InvitationStore(),
    pricingApprovalStore: new PricingApprovalStore(),
    contractEventStore: new ContractEventStore(),
    contractInquiryStore: new ContractInquiryStore(),
    //Trading Floor
    agencyMasterStore: new AgencyMasterStore(),

    // Floor and Staff
    tradingFloorStore: new TradingFloorStore(),
    floorStaffStore: new FloorStaffStore(),
    bussinessTargetStore: new BussinessTargetStore(),
    allocatedCustomerStore: new AllocatedCustomerStore(),

    //Configuration Payment
    configurationPaymentStore: new ConfigurationPaymentStore(),

    //feeTypeStore
    feeTypeStore: new FeeTypeStore(),
    //inquiryFeeTypeSettingStore
    inquiryFeeTypeSettingStore: new InquiryFeeTypeSettingStore(),
    // fee notification
    feeNotificationStore: new FeeNotificationStore(),
    feeReminderLadderStore: new FeeReminderLadderStore(),
    feeNotificationReportStore: new FeeNotificationReportStore(),

    //PhaseCodeStore
    phaseCodeStore: new PhaseCodeStore(),

    //SystemConfigurationStore
    systemConfigurationStore: new SystemConfigurationStore(),

    //ApprovalProcessStore
    approvalProcessStore: new ApprovalProcessStore(),

    // Accounting Data
    accountTypeStore: new AccountTypeStore(),
    accountingDocumentTypeStore: new AccountingDocumentTypeStore(),
    costCenterStore: new CostCenterStore(),
    offsetAccountStore: new OffsetAccountStore(),
    suspenseAccountSettingStore: new SuspenseAccountSettingStore(),

    //ConfigHoliday
    configHolidayStore: new ConfigHolidayStore(),

    //BlockUserStore
    blockUserStore: new BlockUserStore(),

    //ContractInterestSettingStore
    contractInterestSettingStore: new ContractInterestSettingStore(),

    // Import Job Log
    importJobLogStore: new ImportJobLogStore(),

    // Integration Result
    integrationResultStore: new IntegrationResultStore(),

    // Integration Hub
    integrationHubStore: new IntegrationHubStore(),

    // Approval Inbox Outbox
    approvalInboxOutboxStore: new ApprovalInboxOutboxStore(),

    // PinkBook Fee Update
    pinkBookFeeUpdateStore: new PinkBookFeeUpdateStore(),

    // Approver Group
    approverGroupStore: new ApproverGroupStore(),

    // Export Job Log (Feature-0213 Export Core)
    exportJobLogStore: new ExportJobLogStore(),
    codeFormatTemplateStore: new CodeFormatTemplateStore(),
  }
}
